/**
 * @function phaserMount
 * @description Generate a mount point for a Phaser game
 * @param {string} parentMountId - Id of the parent element to mount Phaser game onto
 * @returns {HTMLElement | null} The mount point element
 */

function phaserMount(parentMountId: string): HTMLElement | null {
	const root = document.getElementById(parentMountId);

	let mountEl = document.getElementById("phaser-mount");
	if (root && !mountEl) {
		mountEl = document.createElement("div");
		mountEl.style.flex = "1";
		mountEl.style.width = "100%";
		mountEl.style.overflow = "hidden";
		mountEl.style.touchAction = "none";
		mountEl.id = "phaser-mount";
		root.appendChild(mountEl);
		// Force a synchronous layout pass so Phaser reads the correct clientHeight
		// when Scale.FIT computes the canvas dimensions immediately after this.
		void mountEl.offsetHeight;
	} else {
		mountEl = document.getElementById("phaser-mount");
	}
	return mountEl;
}

export { phaserMount };

export default phaserMount;
